import axios from 'axios'

import type {
  TConfigSectionDto,
  TUpdateConfigsRequest,
  TUpdateConfigsResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

import { PeriodType } from 'types/GlobalCustomer'
import { Category } from 'types/GlobalDashboardGroup'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/configs`

export async function getAll() {
  return getWithRedirect<TConfigSectionDto<Category>[]>(URL)
}

export async function update(body: TUpdateConfigsRequest<PeriodType>) {
  return axios.patch<TUpdateConfigsResponse<Category>>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}
